import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { JProject } from '@ascschool/interface/project';
import { ButtonType } from '@ascschool/interface/setting';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';

interface DataItem {
  stt:number,
  maHS: string,
  hoDem: string,
  ten: string,
  m1: string,
  m2: string,
  m3: string,
  p1: string,
  p2: string,
  p3: string,
  p4: string,
  v1: string,
  v2: string,
  diemtkhk: string,
  tamtinhdtb: string,
  dtb: string,
}
@Component({
  selector: 'app-sample5',
  templateUrl: './sample5.component.html',
  styleUrls: ['./sample5.component.scss']
})
export class Sample5Component implements OnInit {
  @ViewChild('pageSample1', { static: false }) elementPageSample1: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  @ViewChild('pageHeaderTable2', { static: false }) set content(content: ElementRef) {
    if (content) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable2 = content;
    }
  }
  private elementPageHeaderTable: ElementRef;
  private elementPageHeaderTable2: ElementRef;
  heightContentPaddingtop: number = 16;
  heightContentPaddingbottom: number = 16;
  maxHeight:number;
  height: number ;
  @ViewChildren('selects') selects;
  allowSyncTbl: boolean = false;
  rowMax: number = 9;
  colMax: number = 9;
  rowSelected: number;
  colSelected: number;
  idSelected: number;
  valueSelected: string;
  typeColSelected: string;
  width: number;
  columns: any;
  rows: any;
  keyUpCode: number = 38;
  ketDownCode: number = 40;
  keyLeftCode: number = 37;
  keyRightCode: number = 39;
  listOfData: DataItem[] = [
    {
      stt: 1,
        maHS: '1900177326',
        hoDem: 'Dương Thị Thùy',
        ten: 'Anh',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 2,
        maHS: '1900177327',
        hoDem: 'Ngô Phương',
        ten: 'Anh',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 3,
        maHS: '1900177328',
        hoDem: 'Tống Duy',
        ten: 'Anh',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 4,
        maHS: '1900177332',
        hoDem: 'Bùi Xuân',
        ten: 'Đảm',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 5,
        maHS: '1900177333',
        hoDem: 'Hoàng Ngọc',
        ten: 'Đạt',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 6,
        maHS: '1900177334',
        hoDem: 'Ngô Duy',
        ten: 'Đông',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 7,
        maHS: '1900177329',
        hoDem: 'Lê Đăng',
        ten: 'Dũng',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 8,
        maHS: '1900177330',
        hoDem: 'Nguyễn Trọng',
        ten: 'Dũng',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 9,
        maHS: '1900177331',
        hoDem: 'Ngô Thị',
        ten: 'Duyên',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 10,
        maHS: '1900177335',
        hoDem: 'Nguyễn Thị Hương',
        ten: 'Giang',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 11,
        maHS: '1900177336',
        hoDem: 'Dương Thị Khánh',
        ten: 'Hà',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 12,
        maHS: '1900177336',
        hoDem: 'Dương Thị Khánh',
        ten: 'Hiền',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 13,
        maHS: '1900177336',
        hoDem: 'Dương Thị Khánh',
        ten: 'Vui',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 14,
        maHS: '1900177336',
        hoDem: 'Lê Công',
        ten: 'Định',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 15,
        maHS: '1900177336',
        hoDem: 'Nguyễn Vũ',
        ten: 'Hà',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 16,
        maHS: '1900177336',
        hoDem: 'Lê Bằng',
        ten: 'Quang',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 17,
        maHS: '1900177336',
        hoDem: 'Đàm Vĩnh',
        ten: 'Hưng',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 18,
        maHS: '1900177336',
        hoDem: 'Dương Trinh Bửu',
        ten: 'Ngọc',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 19,
        maHS: '1900177336',
        hoDem: 'Liên Văn Thánh',
        ten: 'Giá',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 20,
        maHS: '1900177336',
        hoDem: 'Ninh Dương Lan',
        ten: 'Ngọc',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 21,
        maHS: '1900177336',
        hoDem: 'Dương Thị Khánh',
        ten: 'Hà',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 22,
        maHS: '1900177336',
        hoDem: 'Dương Thị Khánh',
        ten: 'Hà',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 23,
        maHS: '1900177336',
        hoDem: 'Dương Thị Khánh',
        ten: 'Hà',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 24,
        maHS: '1900177336',
        hoDem: 'Dương Thị Khánh',
        ten: 'Hà',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
    {
      stt: 25,
        maHS: '1900177336',
        hoDem: 'Dương Thị Khánh',
        ten: 'Hà',
        m1: 'CNX',
        m2: 'CNX',
        m3: 'CNX',
        p1: 'CNX',
        p2: 'CNX',
        p3: 'CNX',
        v1: 'CNX',
        v2: 'CNX',
        p4: 'CNX',
        diemtkhk: null,
        tamtinhdtb: null,
        dtb: null,
    },
  ];
  editId: string | null = null;
  validateForm!: FormGroup;
  project: JProject;
  btnType: ButtonType;
  buttonTypeEnum = ButtonType;
  shortcuts: ShortcutInput[] = [];
  get breadcrumbs(): string[] {
    return ['THPT', 'Lớp học'];
  }
  constructor(private msg: NzMessageService,
              private fb: FormBuilder,
              private cdRef: ChangeDetectorRef,
              public _authService: AuthService,
              public sizePageService: SizePageService,
              private authQuery: AuthQuery,
              private message: NzMessageService,
    ) { }

  ngOnInit() {
    this.maxHeight = window.innerHeight;
    this.validateForm = this.fb.group({
      khoiLop: [null],
      lopHoc: [null],
      monHoc: [null],
    });
    this.authQuery.userSetting$.subscribe(type => {
      if (type){
        this.btnType = type.btnType;
      }
    });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
    this.cdRef.detectChanges();
    // keyboard
    this.shortcuts.push(
      {
        key: ["ctrl + s"],
        label: "Help",
        description: "Cmd + b",
        command: (e) => this.save(),
        preventDefault: true
      }
    );
  }
  checkCaculateHeight(){
      setTimeout(() => {
        this.height = this.heightfnc();
        this.width = this.widthfnc();
      }, 1);
  }
  save(): void {
    this.message.create('success', `Lưu điểm thành công`);
  }
  heightfnc(){
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.elementPageHeaderTable2,
      this.heightContentPaddingtop,
      this.heightContentPaddingbottom,
      );
  }
  widthfnc(){
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight();
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  submitForm(): void {
    // tslint:disable-next-line: forin
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
  }

  sortNameFn = (a: DataItem, b: DataItem) =>  a.ten.localeCompare(b.ten);

  resetForm(): void {
    this.validateForm.reset();
  }
  startEdit(rowIdx: number, colIdx: number, id: number, typeCol: string): void {
    this.editId = 'row' + rowIdx + 'col' + colIdx;
    this.rowSelected = rowIdx;
    this.colSelected = colIdx;
    this.idSelected = id;
    this.typeColSelected = typeCol;
    this.allowSyncTbl = true;
  }

  stopEdit(): void {
    this.editId = null;
    this.allowSyncTbl = false;
  }
  rowSync(){
    const flatIdx = (this.rowSelected * this.colMax) + this.colSelected;
    const selectEls = this.selects.toArray();
    this.valueSelected = selectEls[flatIdx].value;
    this.listOfData.forEach(element => {
      if (element.stt === this.idSelected){
        element.m1 = this.valueSelected;
        element.m2 = this.valueSelected;
        element.m3 = this.valueSelected;
        element.p1 = this.valueSelected;
        element.p2 = this.valueSelected;
        element.p3 = this.valueSelected;
        element.p4 = this.valueSelected;
        element.v1 = this.valueSelected;
        element.v2 = this.valueSelected;
      }
    });
  }
  columnSync(){
    const flatIdx = (this.rowSelected * this.colMax) + this.colSelected;
    const selectEls = this.selects.toArray();
    this.valueSelected = selectEls[flatIdx].value;
    this.listOfData.forEach(element => {
      if(this.typeColSelected === 'm1'){
        element.m1 = this.valueSelected;
      }else if(this.typeColSelected === 'm2'){
        element.m2 = this.valueSelected;
      }else if(this.typeColSelected === 'm3'){
        element.m3 = this.valueSelected;
      }else if(this.typeColSelected === 'p1'){
        element.p1 = this.valueSelected;
      }else if(this.typeColSelected === 'p2'){
        element.p2 = this.valueSelected;
      }else if(this.typeColSelected === 'p3'){
        element.p3 = this.valueSelected;
      }else if(this.typeColSelected === 'p4'){
        element.p4 = this.valueSelected;
      }else if(this.typeColSelected === 'v1'){
        element.v1 = this.valueSelected;
      }else if(this.typeColSelected === 'v2'){
        element.v2 = this.valueSelected;
      }
    });
  }
  isFocus(row, col){
    if (this.editId === 'row' + row + 'col' + col){
      return true;
    }else{
      return false;
    }
  }
}
